<template>
  <div class="position-relative">
    <v-app-bar class="header-mobile" elevate-on-scroll color="#f7f7f7" app>
      <v-app-bar-nav-icon
        class="menu"
        color="primary"
        @click="showNavigationDrawer"
      />

      <v-sheet class="d-flex justify-center" width="100%" color="transparent">
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            height="46px"
            class="d-block"
          />
        </router-link>
      </v-sheet>
    </v-app-bar>
  </div>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    showNavigationDrawer() {
      window.showNavigationDrawer();
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  left: 15px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
